export enum QualificationTypeEnum {
    PERSON = "person",
    ESTABLISHMENT = "establishment",
}

export const getQualificationTypeLabel = (
    type: QualificationTypeEnum,
): string => {
    switch (type) {
        case QualificationTypeEnum.PERSON:
            return "Persoon";
        case QualificationTypeEnum.ESTABLISHMENT:
            return "Vestiging";
        default:
            return "";
    }
};
